var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-centered",attrs:{"id":"dealcards"}},_vm._l((_vm.cards),function(card,index){return _c('div',{key:index,staticClass:"column is-4"},[(card.description && card.name)?_c('DealCard',{attrs:{"deal":card,"website":_vm.website}}):_vm._e()],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }